// AxisDetails.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import GetAppIcon from '@mui/icons-material/GetApp';
import { Icon, IconButton } from '@mui/material';

const AxisDetails = () => {
  const { id } = useParams();
  const [axis, setAxis] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAxis = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/leagues/${id}/`);
        setAxis(response.data);
      } catch (err) {
        console.error(err);
        setError("خطا در دریافت اطلاعات محور");
      } finally {
        setLoading(false);
      }
    };
    fetchAxis();
  }, [id]);

  if (loading) return <div className="text-center text-lime-400 py-20">در حال بارگذاری...</div>;
  if (error) return <div className="text-center text-red-500 py-20">{error}</div>;
  if (!axis) return null;

  return (
    <div
      dir="rtl"
      className="min-h-screen p-8 text-white"
      style={{
        background: "linear-gradient(135deg, #001a00 0%, #000000 80%)",
      }}
    >
      {/* افکت گرادیانت های سبز */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-lime-700/20 via-lime-500/10 to-black blur-[150px]" />

      <div className="max-w-4xl mx-auto space-y-8 relative z-10">
       
        {/* تصویر پس‌زمینه‌دار */}
        {axis.pic && (
          <div
            className="flex gap-4 items-center rounded-2xl overflow-hidden mb-2 border-lime-600/40 shadow-[0_0_25px_rgba(132,255,132,0.2)]"
          >
           
            <img
              src={axis.pic}
              alt={axis.name}
              className="w-32 object-cover  hover:scale-[1.02] transition-transform duration-500"
            />
             <div>
                 <h1 className="text-2xl md:text-2xl font-bold text-lime-400 drop-shadow-[0_0_15px_rgba(132,255,132,0.6)]">
          {axis.name}
        </h1>
        <p className="text-gray-300 leading-relaxed">{axis.description}</p>

            </div>
          </div>
        )}

        {/* لیست فایل‌ها */}
        <div className="bg-black/40 backdrop-blur-md rounded-2xl p-6 border border-lime-600/30 shadow-lg">
          <h2 className="text-2xl font-bold text-white mb-4">فایل‌های مربوطه</h2>

          {axis.files?.length > 0 ? (
            <ul className="">
              {axis.files.map(file => (
                <li
                  key={file.id}
                  className="flex justify-between items-center bg-gradient-to-r from-lime-900/30 to-black hover:from-lime-800/40 hover:to-lime-900/20 p-3 rounded-xl transition-all"
                >
                    <Link to={file.url} className="text-black hover:text-white bg-lime-600 p-2 rounded-md text-sm flex items-center transition-all">
                    <Icon
                    component="a"
                    href={file.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    size="small"
                    className="text-lime-400 hover:text-lime-300"
                  >
                    <GetAppIcon />
                  </Icon>
                     <span className=" mr-2">{file.name}</span>
                  
                    </Link>
                 
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-400">فایلی برای این محور ثبت نشده است.</p>
          )}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/"
            className="inline-block bg-lime-500 text-black font-semibold px-6 py-3 rounded-xl hover:bg-lime-400 transition"
          >
            بازگشت به صفحه‌ی محورها
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AxisDetails;
